import { useEffect, useRef } from "react";

interface InfiniteQueryLike {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => Promise<unknown>;
}

/**
 * 末尾の番兵要素が見えたら次のページを取りに行く。
 * 返した ref を一覧の末尾に置いた要素へ付ける。
 */
export function useLoadMoreSentinel({
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
}: InfiniteQueryLike) {
  const sentinel = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const node = sentinel.current;
    if (node === null || !hasNextPage) return;
    const observer = new IntersectionObserver((entries) => {
      if (entries[0]?.isIntersecting === true && !isFetchingNextPage) {
        void fetchNextPage();
      }
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  return sentinel;
}
